import {
  GET_DELIVERY_CHARGES_SLABS_RESPONSE,
  UPDATE_DELIVERY_CHARGES_SLABS_RESPONSE,
} from "./actionTypes";

import produce from "immer";

export const initialState = {
  deliveryChargesData: [],
  deliveryChargesApiResponse: null,
};

const siteSetting = (state = initialState, action) =>
  produce(state, (draft) => {
    let response;
    switch (action.type) {
      case GET_DELIVERY_CHARGES_SLABS_RESPONSE:
        response = action.payload.apiResponse;
        if (response.isSuccessResponse) {
          draft.deliveryChargesData = response.responseData;
        } else {
          draft.deliveryChargesData = [];
        }
        break;

      case UPDATE_DELIVERY_CHARGES_SLABS_RESPONSE:
        draft.deliveryChargesApiResponse = action.payload.apiResponse;
        break;

      default:
        state = { ...state };
        break;
    }
  });

export default siteSetting;
